declare global {
    interface RouterMeta {
        title: string;
				redirect?: string;
    }
    interface Router {
        path: string;
		redirect?: string;
        name: string;
        icon?: string;
        permission?: string;
        meta?: RouterMeta;
        component: any;
        children?: Array<Router>;
    }
    interface System {
        import(request: string): Promise<any>
    }
    var System: System
}
// import login from '../views/login.vue'
import home from '../views/home/home.vue'
import main from '../views/main.vue'
import forgetpassword from '../views/forgetPassword.vue'

export const locking = {
    path: '/locking',
    name: 'locking',
    component: () => import('../components/lockscreen/components/locking-page.vue')
};


export const loginRouter: Router = {
    path: '/',
    name: 'login',
    meta: {
        title: '登录'
    },
    component: () => import('../views/login.vue')
};
export const forgetPasswordRouter: Router = {
    path: '/forgetpassword',
    name: 'forgetpassword',
    meta: {
        title: 'forgetPassword'
    },
    component: () => import('../views/forgetPassword.vue')
};
export const sessionaiRouter: Router = {
    path: '/sessionai',
    name: 'sessionai',
    meta: {
        title:'sessionai'
    },
    component: () => import('../views/sessionai.vue')
};
export const sessionai2Router: Router = {
    path: '/sessionai2',
    name: 'sessionai2',
    meta: {
        title:''
    },
    component: () => import('../views/sessionai2.vue')
};
export const sessionainewRouter: Router = {
    path: '/sessionainew',
    name: 'sessionainew',
    meta: {
        title:''
    },
    component: () => import('../views/sessionainew.vue')
};
export const newsRouter: Router = {
    path: '/newsdetail',
    name: 'newsdetail',
    meta: {
        title: '新闻详情'
    },
    component: () => import('../views/newsDetail.vue')
};
export const noticeRouter: Router = {
    path: '/noticedetail',
    name: 'noticedetail',
    meta: {
        title: '通知详情'
    },
    component: () => import('../views/noticeDetail.vue')
};
export const xuexiDetailRouter: Router = {
    path: '/xuexidetail',
    name: 'xuexidetail',
    meta: {
        title: '聚力百年'
    },
    component: () => import('../views/xuexiDetail.vue')
};
export const mustReadDetailRouter: Router = {
    path: '/mustreaddetail',
    name: 'mustreaddetail',
    meta: {
        title: '员工必读详情'
    },
    component: () => import('../views/mustReadDetail.vue')
};
export const downloadRouter: Router = {
    path: '/download',
    name: 'download',
    meta: {
        title: '下载'
    },
    component: () => import('../views/download.vue')
};
export const downloadnewRouter: Router = {
    path: '/downloadnew',
    name: 'downloadnew',
    meta: {
        title: '下载'
    },
    component: () => import('../views/downloadNew.vue')
};
export const downloadafterRouter: Router = {
    path: '/downloadafter',
    name: 'downloadafter',
    meta: {
        title: '下载'
    },
    component: () => import('../views/downloadAfter.vue')
};
export const accountActivationRouter: Router = {
    path: '/accountactivation',
    name: 'accountactivation',
    meta: {
        title: '账户激活'
    },
    component: () => import('../views/accountActivation.vue')
};
export const statisticsRouter: Router = {
    path: '/statistics',
    name: 'statistics',
    meta: {
        title: 'ActiveStatistics'
    },
    component: () => import('../views/statistics.vue')
};
export const newsListRouter: Router = {
    path: '/newsList',
    name: 'newsList',
    meta: {
        title: '新闻列表'
    },
    component: () => import('../views/newsList.vue')
};
export const newsGroupRouter: Router = {
    path: '/newsgroup',
    name: 'newsgroup',
    meta: {
        title: '新闻组'
    },
    component: () => import('../views/newsGroup.vue')
};
export const noticeListRouter: Router = {
    path: '/noticeList',
    name: 'noticeList',
    meta: {
        title: '通知列表'
    },
    component: () => import('../views/noticeList.vue')
};
export const directoriesRouter: Router = {
    path: '/directories',
    name: 'directories',
    meta: {
        title: '文件列表'
    },
    component: () => import('../views/directories.vue')
};

export const mustreadListRouter: Router = {
    path: '/mustreadList',
    name: 'mustreadList',
    meta: {
        title: '员工必读列表'
    },
    component: () => import('../views/mustreadList.vue')
}; 
export const answerListRouter: Router = {
    path: '/answerList',
    name: 'answerList',
    meta: {
        title: '反馈意见'
    },
    component: () => import('../views/answerList.vue')
};
export const answerDetailRouter: Router = {
    path: '/answerDetail',
    name: 'answerDetail',
    meta: {
        title: '反馈意见'
    },
    component: () => import('../views/answerDetail.vue')
};

export const commentauditRouter: Router = {
    path: '/commentaudit',
    name: 'commentaudit',
    meta: {
        title: '评论审核'
    },
    component: () => import('../views/commentAudit.vue')
};
export const otherRouters: Router = {
    path: '/main',
    name: 'main',
    permission: '',
    meta: { title: '首页' },
    component: main,
    children: [
        { path: 'home', meta: { title: '首页' }, name: 'home', component: () => import('../views/home/home.vue') }
    ]
}
export const testquestionRouter: Router = {
    path: '/testquestion',
    name: 'testquestion',
    meta: {
        title: '试卷'
    },
    component: () => import('../views/testquestion.vue')
};
export const questionnaireRouter: Router = {
    path: '/questionnaire',
    name: 'questionnaire',
    meta: {
        title: '问卷'
    },
    component: () => import('../views/questionnaire.vue')
};
export const voteRouter: Router = {
    path: '/vote',
    name: 'vote',
    meta: {
        title: '投票'
    },
    component: () => import('../views/vote.vue')
};
export const questionnaireuserRouter: Router = {
    path: '/questionnaireuser',
    name: 'questionnaireuser',
    meta: {
        title: '问卷'
    },
    component: () => import('../views/questionnaireuser.vue')
};
export const testquestionuserRouter: Router = {
    path: '/testquestionuser',
    name: 'testquestionuser',
    meta: {
        title: '试卷'
    },
    component: () => import('../views/testquestionuser.vue')
};
export const voteuserRouter: Router = {
    path: '/voteuser',
    name: 'voteuser',
    meta: {
        title: '投票'
    },
    component: () => import('../views/voteuser.vue')
};

export const changePasswordRouter: Router = {
    path: '/setting',
    name: 'setting_hide',
    meta: { title: '修改密码' },
    component: main,
    children: [
        {
            path: 'password-change',
            meta: { title: '修改密码' },
            name: 'password_change_hide',  // 必填，且不能和其父路由的name不一致（与其他任何路由的name值都不能一致）
            component: () => import('../views/setting/user/change-password.vue')
        }
    ]
}


export const ilearningErrorPageRouter: Router = {
    path: '/ilearningErrorPage',
    name: 'ilearningErrorPage',
    meta: {
        title: 'i-learning'
    },
    component: () => import('../views/ilearningErrorPage.vue')
};
export const iscRouter: Router = {
    path: '/iscDetail',
    name: 'iscDetail',
    meta: {
        title: 'IT报修详情'
    },
    component: () => import('../views/iscDetail.vue')
};


export const appRouters: Array<Router> = [];
export const routers = [
    loginRouter,
    locking,
    ...appRouters,
    otherRouters,
	newsRouter,
	noticeRouter,
	downloadRouter,
	downloadnewRouter,
	downloadafterRouter,
	accountActivationRouter,
	statisticsRouter,
	newsListRouter,
	noticeListRouter,
	mustreadListRouter,
	mustReadDetailRouter,
	xuexiDetailRouter,
	testquestionRouter,
	questionnaireRouter,
	voteRouter,
	questionnaireuserRouter,
	testquestionuserRouter,
	voteuserRouter,
 
	newsGroupRouter,
	commentauditRouter,
	forgetPasswordRouter,
	sessionaiRouter,
	sessionainewRouter,
	sessionai2Router,
	answerListRouter,
	answerDetailRouter,
	
	ilearningErrorPageRouter,
	iscRouter,
	directoriesRouter
];
